/* eslint-disable @typescript-eslint/no-var-requires */
const hiayConfig = require('hiya-common/config.js')
const package = require('./package.json')

module.exports = {
  project: package.name,
  devPort: 7200,
  devStaticPort: 7201,
  tracingOrigins: [
    'https://version-habib-web.mehiya.com/', // 根据H5 host来修改 TODO:
    'http://version-habib-web-test.youyisia.com/', // 根据H5 host来修改
  ],
  ...hiayConfig,
}
